/* eslint-disable array-callback-return */
import React from "react"
import { Col, Modal, ModalFooter, Row } from "react-bootstrap"
import { Button, DropDown } from "../../../components"
import { useAppSelector } from "../../../redux/Hooks/Hook"
import { toast } from "react-toastify";

const FilterModal = (props: any) => {
    const { show, handleClose, handleFilterSubmit, sportName, setSportName, courtName, setCourtName, bookingType, setBookingType, bookingStatus, setBookingStatus, paidStatus, setPaymentStatus, paidMode, setPaymentMode } = props
    const { courtBookingType, courtBookingStatus, paymentStatus, paymentMode } = useAppSelector(state => state.enumsArray.Enums)
    const { AllSportsData, sportErrorMessage } = useAppSelector(state => state.sportList)
    const { AllCourtsData, errorMessage } = useAppSelector(state => state.courtsList)
    const BookingTypeKey: string[] = Object.values(courtBookingType)
    const BookingTypevalues: string[] = Object.keys(courtBookingType)
    const BookingStatusKey: string[] = Object.values(courtBookingStatus)
    const BookingStatusvalues: string[] = Object.keys(courtBookingStatus)
    const PaymentStatusKey: string[] = Object.values(paymentStatus)
    const PaymentStatusvalues: string[] = Object.keys(paymentStatus)
    const PaymentModeKey: string[] = Object.values(paymentMode)
    const PaymentModevalues: string[] = Object.keys(paymentMode)

    if (errorMessage || sportErrorMessage) {
        toast.error(errorMessage.message)
    }

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header className="border-0 pb-0 pb-2" closeButton>
                <Modal.Title id="contained-modal-title-vcenter fw-semibold">Filter</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col lg={6}>
                        <div className="mb-3">
                            <label htmlFor="btype" className="form-label">Booking Type</label>
                            <DropDown id="btype" name="btype" value={bookingType} onChange={(e: any) => setBookingType(e.target.value)} >
                                <option value="" >Select Booking Type</option>
                                {BookingTypeKey?.map((item: string, index: number) => {
                                    if (item !== "Associate") {
                                        return (
                                            <option key={"booking-type-" + BookingTypevalues[index]} value={BookingTypevalues[index]} >{item}</option>
                                        )
                                    }
                                })}
                            </DropDown>
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="mb-3">
                            <label htmlFor="bstatus" className="form-label">Booking Status</label>
                            <DropDown id="bstatus" name="bstatus" value={bookingStatus} onChange={(e: any) => setBookingStatus(e.target.value)} >
                                <option value="" >Select Booking Status</option>
                                {BookingStatusKey?.map((item: string, index: number) => {
                                    return (
                                        <option key={"booking-status-" + BookingStatusvalues[index]} value={BookingStatusvalues[index]} >{item === "Ongoing" ? "Running" : item}</option>
                                    )
                                })}
                            </DropDown>
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="mb-3">
                            <label htmlFor="pstatus" className="form-label">Payment Status</label>
                            <DropDown id="pstatus" name="pstatus" value={paidStatus} onChange={(e: any) => setPaymentStatus(e.target.value)} >
                                <option value="" >Select Payment Status</option>
                                {PaymentStatusKey?.map((item: string, index: number) => {
                                    return (
                                        <option key={"payment-status-" + PaymentStatusvalues[index]} value={PaymentStatusvalues[index]} >{item}</option>
                                    )
                                })}
                            </DropDown>
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="mb-3">
                            <label htmlFor="pmode" className="form-label">Payment Mode</label>
                            <DropDown id="pmode" name="pmode" value={paidMode} onChange={(e: any) => setPaymentMode(e.target.value)} >
                                <option value="" >Select Payment Mode</option>
                                {PaymentModeKey?.map((item: string, index: number) => {
                                    return (
                                        <option key={"payment-mode-" + PaymentModevalues[index]} value={PaymentModevalues[index]} >{item}</option>
                                    )
                                })}
                            </DropDown>
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="mb-3">
                            <label htmlFor="sports" className="form-label">Sport</label>
                            <DropDown id="sports" name="sports" value={sportName} onChange={(e: any) => setSportName(e.target.value)} >
                                <option value="" >Select Sport</option>
                                {AllSportsData?.map(item => {
                                    return (
                                        <option key={"sport-" + item.id} value={`${item.id}`}>{item.name}</option>
                                    )
                                })}
                            </DropDown>
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="mb-3">
                            <label htmlFor="court" className="form-label">Court</label>
                            <DropDown id="court" name="court" value={courtName} onChange={(e: any) => setCourtName(e.target.value)} >
                                <option value="" >Select Court</option>
                                {AllCourtsData?.map(item => {
                                    return (
                                        <option key={"court-" + item.id} value={`${item.id}`}>{item.name}</option>
                                    )
                                })}
                            </DropDown>
                        </div>
                    </Col>
                </Row>
                <ModalFooter>
                    <Col lg={12} className="text-center">
                        <Button onClick={handleFilterSubmit} type="button" bname="Submit" name="submit" id="submit" className="btn btn-primary rounded-1 mt-1"></Button>
                    </Col>
                </ModalFooter>

            </Modal.Body>

        </Modal>
    )
}

export { FilterModal }
